import styled from "styled-components"

export interface HeroProps {
  header_height: string
}
export interface HeroImageProps {
  mobileOnly: boolean
  header_height: string
}

export const StyledHero = styled.div<HeroProps>`
  @media (min-width: ${props => props.theme.breakPoints.tablet}) {
    position: relative;
    padding-bottom: 64px;
  }
`
export const StyledHeroImage = styled.div<HeroImageProps>`
  @media (min-width: ${props => props.theme.breakPoints.tablet}) {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin: 0 auto;
    position: relative;
    height: 540px; 
    overflow: hidden;

    & > div{
      height: 100%;
      width: 100%;
      max-width: calc(${props => props.theme.breakPoints.wide} - 64px);

      & > img, & > video{
        object-fit: cover;
        width: 100%;
      }
    }
  }
  @media (max-width: ${props => props.theme.breakPoints.mobile}) {
    min-height: 250px;
  }

`
export const StyledHeroOverImage = styled.div`
  @media (min-width: ${props => props.theme.breakPoints.tablet}) {
      width: 100%;
      position: absolute;
      bottom: 32px;
      left: 0;
      display: flex;
      justify-content: center;
  }
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    width: 100%;
  }
`
export const StyledHeroContainer = styled.div`
  @media (min-width: ${props => props.theme.breakPoints.tablet}) {
    ${(props) => props.theme.mixins.container};
    padding: 0;
  }
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    width: 100%;
  }
`

export const StyledHeroCard = styled.div`
box-shadow: 0 1px 1px ${props => props.theme.colors.darkGrey05}, 
0 2px 2px ${props => props.theme.colors.darkGrey05}, 
0 4px 4px ${props => props.theme.colors.darkGrey05}, 
0 8px 8px ${props => props.theme.colors.darkGrey05}, 
0 16px 16px ${props => props.theme.colors.darkGrey05};
  background-color: ${(props) => props.theme.colors.white};
  @media (min-width: ${props => props.theme.breakPoints.tablet}) {
    width: 50%;
    padding: 32px;
  }
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    padding: 24px 32px;
    width: 100%;
  }
  @media (max-width: ${props => props.theme.breakPoints.mobile}) {
    padding: 24px 16px;
    width: 100%;
  }
`
export const StyledHeroTitle = styled.h1`
    ${props => props.theme.mixins.h1}
    &:after{
        ${props => props.theme.mixins.headingAccent};
    }
`
export const StyledHeroSubTitle = styled.div`
    margin: 24px 0 0; 
    & p{
      font-family: ${(props) => props.theme.fonts.circularBook};
      font-size: 18px;
      line-height: 22px;
      color: ${(props) => props.theme.colors.darkGrey};
      margin: 0;
      @media (max-width: ${(props) => props.theme.breakPoints.tablet}){
          font-size: 16px;
          line-height: 20px;
      }
        color: ${props => props.theme.colors.darkGrey80};

        & b{
            color: ${props => props.theme.colors.darkGrey};
        }
    }
`
export const StyledHeroDescription = styled.div`
    margin: 24px 0 0; 

    & p{
        ${props => props.theme.mixins.body}
    }
`
export const StyledHeroButtons = styled.div`
    margin: 24px -8px -8px;
    display: flex;
    flex-wrap: wrap;
    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
      margin: 16px -8px -8px;
    }

    & > div, & > button, & > a{
      margin: 8px;
    }

    & .button-v2--text{
        padding-top: 0;
        padding-bottom: 0;
        min-height: 0;
    }
`